export default "__VITE_ASSET__8cbe9d17__"